import React from 'react'
import TypeColorContainer from './TypeColorContainer'

const TypeColor = props => (
  <TypeColorContainer data-test="component-configurator-type-color" {...props} />
)

export default TypeColor
